// React Basic and Bootstrap
import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

//Import Components
import SectionTitle from "../../components/Shared/section-title";
import FeatureBox from "./feature-box";

//import images
import featureImg from '../../images/app/feature.png';

class Feature extends Component {

    constructor(props) {
        super(props);
        this.state = {
            features : [
                { icon : "mdi-alarm-check", title : "Rinde en tiempo real", desc : "Con solo unos pocos pasos ya tu gasto es rendido y respaldado." },
                { icon : "mdi-brush", title : "Gran experiencia de usuario", desc : "Posee un diseño minimalista siendo fácil de usar y de rápida adopción usuarios." },
                { icon : "mdi-cryengine", title : "Escaneo y lectura", desc : "Con nuestro OCR te facilitamos el ingreso de los datos, cumpliendo con las políticas de tu organización." },
                { icon : "mdi-clock-outline", title : "Ahorra tiempo y costos", desc : "Acelera tu proceso, mejora el cumplimiento de tu política de gastos e integralo con tu sistema de ERP." },
                { icon : "mdi-check-decagram", title : "Automatiza tus aprobaciones", desc : "Configura políticas que se apliquen al momento de rendir, agilizando tu proceso de aprobación." },
                { icon : "mdi-google-analytics", title : "Toma mejor tus decisiones", desc : "Te entregamos toda reportería y analítica que necesitas para tomar mejores decisiones en tiempo real." },
            ]
        }
    }

    componentDidMount(){
        var sectionTitles=document.getElementsByName("maintitle");
        sectionTitles[0].classList.remove("mb-4");
        sectionTitles[0].classList.remove("pb-2");
        sectionTitles[0].classList.add("mb-60");
    }
    render() {
        return (
            <React.Fragment>
                <section className="section bg-light" id="features">
                    <Container>
                        {/* section title */}
                        {/* <SectionTitle title="Una herramienta que le encantará a tu equipo" desc="Te facilitamos el autorservicio, automatizamos los procesos y optimizamos la administración." /> */}
                        <SectionTitle title="Una herramienta que le encantará a tu equipo" desc="" />

                        <Row className="justify-content-center align-items-center">
                            <Col lg="10" md="10">
                                <Row>
                                    <FeatureBox features={this.state.features} />
                                </Row>
                            </Col>
                            {/* <Col lg="4" md="4" xs="12" className="pt-2 pt-sm-0 text-center text-md-right">
                                <img src={featureImg} className="img-fluid" alt="" />
                            </Col> */}
                        </Row>
                    </Container>
                </section>
            </React.Fragment>
        );
    }
}

export default Feature;
